import { Navigate, useParams } from "react-router-dom";

export default function PlaidConnectRedirect() {
  const { token } = useParams<{ token: string }>();
  if (!token) return <Navigate to="/" replace />;
  return <Navigate to={"/flow/" + token} replace />;
}
